import V from "@/common/assets/image/moneyFortune/Role/V.webp"
import Amber from "@/common/assets/image/moneyFortune/Role/Amber.webp"
import ARK from "@/common/assets/image/moneyFortune/Role/ARK.webp"
import DoKwon from "@/common/assets/image/moneyFortune/Role/DoKwon.webp"
import JiuCai from "@/common/assets/image/moneyFortune/Role/JiuCai.webp"
import Kordan from "@/common/assets/image/moneyFortune/Role/Kordan.webp"
import LaoZi from "@/common/assets/image/moneyFortune/Role/LaoZi.webp"
import MaJi from "@/common/assets/image/moneyFortune/Role/MaJi.webp"
import Musk from "@/common/assets/image/moneyFortune/Role/Musk.webp"
import Rothschild from "@/common/assets/image/moneyFortune/Role/Rothschild.webp"
import ZongBenCong from "@/common/assets/image/moneyFortune/Role/ZongBenCong.webp"

import resultV from "@/common/assets/image/moneyFortune/resultRoleImgs/share-V.webp"
import resultAmber from "@/common/assets/image/moneyFortune/resultRoleImgs/share-Amber.webp"
import resultARK from "@/common/assets/image/moneyFortune/resultRoleImgs/share-ARK.webp"
import resultDoKwon from "@/common/assets/image/moneyFortune/resultRoleImgs/share-DoKwon.webp"
import resultJiuCai from "@/common/assets/image/moneyFortune/resultRoleImgs/share-JiuCai.webp"
import resultKordan from "@/common/assets/image/moneyFortune/resultRoleImgs/share-Kordan.webp"
import resultLaoZi from "@/common/assets/image/moneyFortune/resultRoleImgs/share-LaoZi.webp"
import resultMaJi from "@/common/assets/image/moneyFortune/resultRoleImgs/share-MaJi.webp"
import resultmusk from "@/common/assets/image/moneyFortune/resultRoleImgs/share-Musk.webp"
import resultRothschild from "@/common/assets/image/moneyFortune/resultRoleImgs/share-Rothschild.webp"
import resultZongBenCong from "@/common/assets/image/moneyFortune/resultRoleImgs/share-ZongBenCong.webp"

export const GetAndShare = {
  API: "fortunego-by-kryptogo",
  APIPOST: `${process.env.NEXT_PUBLIC_CMS_HOST}/api/money-fortunes`,
  copylink: `https://www.kryptogo.com/money-fortune?utm_source=Web&utm_medium=fortune&utm_campaign=221116`,
  shareText: "分享到FB",
  shareURL: `https://www.facebook.com/sharer/sharer.php?u=https://www.kryptogo.com/money-fortune/`,
  resultToUrl: null,
  completeType: "name",
  OGimg: "https://i.ibb.co/T4VWkv7/home.webp",
  OGtitle: "超準幣圈心理測驗：你的賺大錢可能性？！",
  OGurl: "https://www.kryptogo.com/money-fortune"
}

export const ResultDate = [
  {
    roleID: "Bitcoin",
    name: "神秘紙上富翁 - 中本聰",
    AKA: "比特幣創始人",
    chance: "80%",
    saying: "不屬於自己的就無法留住，不如親手創造吧!",
    summary:
      "自稱日裔美國人，他發佈了首個比特幣，並正式啟動了比特幣金融系統，持有約一百萬個比特幣（現值 160億 美金）。擁有最強紙上財富，改變世界經濟但低調神秘，真實身份仍是個謎。",
    analysis: {
      first:
        "你對於自己的目標十分清晰，一旦下定決心就會付出全力執行，是少見的做策略高手，賺錢對你來說，從來都不是難事，從失敗的經驗獲得養份，更新的思路去達到更高領域。",
      second: "當一切都行不通時，回歸簡單的邏輯就可以了。"
    },
    investment: "自己的腦袋",
    befit: [
      { name: "羅斯柴爾德", img: Rothschild },
      { name: "V神", img: V }
    ],
    img: ZongBenCong,
    resultImg: resultZongBenCong
  },
  {
    roleID: "V",
    name: "以太坊創世神 - V神",
    AKA: "以太坊聯合創始人",
    chance: "85%",
    saying: "當模式變得過於複雜，用更多時間去進行簡化也許是好的。",
    summary:
      "曾經是《魔獸世界》重度玩家，從遊戲中體悟中心化帶來的不公義。17歲時，了解比特幣，20歲時推出以太坊，目前坐擁破億的資產。所以說，打電動的孩子不會變壞:)",
    analysis: {
      first:
        "你執行力強，喜歡思考問題的本質，認為投資的價值並不是投機。個性主動積極的你善於處理困難跟挑戰，而不是被動的等別人出手救援。",
      second: "永遠不要相信任何人，相信程式碼跟硬實力就對了"
    },
    investment: "加密貨幣、衍生性金融商品",
    befit: [
      { name: "Do Kwon", img: DoKwon },
      { name: "老子", img: LaoZi }
    ],
    img: V,
    resultImg: resultV
  },
  {
    roleID: "SuperRich",
    name: "最強富十代 - 羅斯柴爾德",
    AKA: "傳說統治權世界經濟的家族",
    chance: "90%",
    saying: "讓我傳授致富心法：一是投資，二是投胎",
    summary:
      "地表最神祕的猶太家族羅斯柴爾德所擁有的資產有 50 兆美元，從 18 世紀發跡至今，跨足銀行業及利潤巨大產業。 任何能賺錢的地方，都有我們家族的掌控呢！",
    analysis: {
      first:
        "冷靜沉著的你，不會沉浸於暴漲殺跌的遊戲之中。在風險高的投資中，還是可以用更具有策略的作法，賺到你應該獲得的報酬。",
      second: "別過度在意過去，任何趨勢不會永遠延續。"
    },
    investment: "房地產、投資公司、軍武",
    befit: [
      { name: "中本聰", img: ZongBenCong },
      { name: "V神", img: V }
    ],
    img: Rothschild,
    resultImg: resultRothschild
  },
  {
    roleID: "Musk",
    name: "現代版鋼鐵人 - 馬斯克",
    AKA: "現實版鋼鐵人",
    chance: "100%",
    saying: "財富只是我實現理想的武器，剛好我的武器特別多",
    summary:
      "馬斯克是 SpaceX 創始人，特斯拉執行長，享有 32% 的股權，價值 10 億美元，有 10 名兒女。一生為人類科學及生育有極大貢獻。",
    analysis: {
      first:
        "身為夢想家的你，一有目標就奮不顧身的往前衝，執行力與專注的心能夠讓你真正強大。雖然不見得總是一帆風順，但堅持跟努力將資訊研究得更透測，最終還是會獲得好的回報。 ",
      second: "不可能同時有低風險高報酬的事情，分散、分散、再分散。"
    },
    investment: "創業、創造生命",
    befit: [
      { name: "老子", img: LaoZi },
      { name: "Do Kwon", img: DoKwon }
    ],
    img: Musk,
    resultImg: resultmusk
  },
  {
    roleID: "Jeff",
    name: "穩賺大哥 - 麻吉大哥",
    AKA: "",
    chance: "99%",
    saying: "團隊做事很酷，賺錢是條不歸路，是麻吉就拿住。",
    summary:
      "創立first7直播、Swag 、 秘銀等，幣圈巨鯨，斜槓許多事業，首批 DeFi 流動性玩家。流言說待過的項目很容易被割，鄉民戲稱大割。",
    analysis: {
      first:
        "身為商業鬼才的你，可以掌握任何投資機會，敏銳的嗅覺讓你在各領域都極可能獲得成功，十分懂得市場局勢與掌握投資節奏。",
      second: "但別老想猜測高低點，『大哥不可能永遠是對的』！"
    },
    investment: "各項區塊鏈項目、新潮投資",
    befit: [
      { name: "韭菜", img: JiuCai },
      { name: "馬斯克", img: Musk }
    ],
    img: MaJi,
    resultImg: resultMaJi
  },
  {
    roleID: "Oldman",
    name: "佛系賺錢法 - 老子",
    AKA: "",
    chance: "50%",
    saying: "風險是來自於不知道自己在做什麼，所以我選擇什麼都不做😁",
    summary:
      "不是你爸那個老子，是世人尊稱為「老子」，其著作被人們廣泛稱為《道德經》，為道家和道教的經典。老子主張無為而治、天人合一，性命雙修的始祖。",
    analysis: {
      first:
        "比起獲利更重視安全的你，將資產分散放在多個信任的地方，在投資之前細心思量、慎選標的，在市場起伏大的時候，長期的投資報酬率也相當驚人。",
      second: "佛系投資，少輸為贏！"
    },
    investment: "ETF , S&P500",
    befit: [
      { name: "馬斯克", img: Musk },
      { name: "韭菜", img: JiuCai }
    ],
    img: LaoZi,
    resultImg: resultLaoZi
  },
  {
    roleID: "Amber",
    name: "大起大落 - 安柏·蘿拉·赫德",
    AKA: " 強尼戴普前妻",
    chance: "30%",
    saying: "被套牢時流的淚，都是當初相信別人腦子進的水",
    summary:
      "與同劇演員強尼戴普開始約會，兩人於2013年訂婚，2016年安柏提出離婚。後來兩人互相控告，法官裁定，安柏赫德最後須支付美金1035萬元。家暴台灣請打113專線。",
    analysis: {
      first:
        "尊重專業領域的你，十分信任各路投資專家的看法，但盲目信任同一個策略或專家，會增加翻船的可能性，可以把雞蛋放在不同籃子裡，佈局長遠的投資規劃。",
      second: "專家說過的，市場上也都知道了，你也跑不掉了:)"
    },
    investment: "好萊塢、GameFi 、NFT",
    befit: [
      { name: "木頭姐", img: ARK },
      { name: "麻吉大哥", img: MaJi }
    ],
    img: Amber,
    resultImg: resultAmber
  },
  {
    roleID: "ARK",
    name: "千金難買早知道 - ARK木頭姐",
    AKA: "",
    chance: "65%",
    saying: "我身為一個過來人，建議你是別過來了",
    summary:
      "凱薩琳·伍德，現任方舟投資總裁，以投資破壞性創新科技公司的高回報獲得廣泛關注，有「科技股女股神」之稱，但ARKK在2021年末大跌，並在2022年後持續走低，潮水不知道什麼時候才會退？",
    analysis: {
      first:
        "對知識有信仰的你，做任何決定之前都經過深度研究，財報、新聞、市場走向都是你的武器！",
      second: "被動式的指數型基金也許是度過寒冬的好選擇。"
    },
    investment: "任何投資商品",
    befit: [
      { name: "安柏", img: Amber },
      { name: "V神", img: V }
    ],
    img: ARK,
    resultImg: resultARK
  },
  {
    roleID: "Loser",
    name: "有夢最美 - 韭菜 94 ni",
    AKA: "",
    chance: "50%",
    saying: "幣圈一天，人間十年，人家不玩了，可以把錢還給我嗎？",
    summary:
      "是石蒜科蔥屬的多年生草本植物，叢生，葉細長而扁，開小白花、具宿根性、耐寒且喜歡在陰濕肥沃的環境生長(低賤之意)，韭菜採收容易，可用於園藝，在世界廣泛種植，並在一些國家被列為入侵植物。",
    analysis: {
      first:
        "心態開放的你，關注各種投資新聞。經歷過多次賺錢、賠錢的循環，會慢慢找到自己適合的投資方式，不論是賺是賠，經驗都會成為未來的養分，在投資市場無畏前行。",
      second: "投資股市，接受波動，投資失敗，接受心痛。"
    },
    investment: "一顆風雨無阻的心，好好生活",
    befit: [
      { name: "麻吉大哥", img: MaJi },
      { name: "木頭姐", img: ARK }
    ],
    img: JiuCai,
    resultImg: resultJiuCai
  },
  {
    roleID: "DoKwon",
    name: "區塊鏈大割 - Do Kwon",
    AKA: "Terra 創始人",
    chance: "66%",
    saying: "有我的腦袋加上『你們的錢』，就能成就非凡",
    summary:
      "權道亨（Kwon Do-hyung)，LUNA 創辦人，該區塊鏈市值一度高達 600 億美元。在短短一個月內，LUNA 幣值從 115 美元跌到幾乎 0 美元。被國際刑警發佈全球紅色通緝，目前下落只有他的朋友才知道。",
    analysis: {
      first:
        "天資聰穎的你成就非凡，對於投資項目有極高的掌握度，並且能夠快速上手，獲利滿滿。然而，多傾聽別人的投資見解加以整合，不論市場起伏多劇烈，你都將是最後的贏家。",
      second: "可以檢視基本面有沒有改變，資產價格是否被高估？自信是否過剩？"
    },
    investment: "穩定幣、LUNAC",
    befit: [
      { name: "V神", img: V },
      { name: "安柏", img: Amber }
    ],
    img: DoKwon,
    resultImg: resultDoKwon
  },
  {
    roleID: "Kordan",
    name: "黃金Kordan",
    AKA: "有first4隻手的工程師",
    chance: "first00%",
    saying: "世界上的工程師只有兩種：Kordan 和 Kordan 以外的",
    summary:
      "Kordan , 是 COBINHOOD 的前總經理，現在創辦了監理科技 (RegTech) 新創 KryptoGO，主攻 KYC 與 去中心化錢包，目前正在帶著 KryptoGO 團隊起飛，預計在美國 IPO 。",
    analysis: {
      first:
        "思路跟 Kordan 一模一樣的你，是天選之人、天之驕子、絕代雙驕、風華絕代，任何投資建議都無法給你，因為你所有的決定都是最正確的決定。如果你拿到這張NFT ，請聯絡 KryptoGO 團隊 ， Kordan 本人將會與你展開一場別開生面的見面會。",
      second: "早安"
    },
    investment: "KryptoGO ",
    befit: [
      { name: "歐爸", img: Rothschild },
      { name: "超帥歐爸", img: V }
    ],
    img: Kordan,
    resultImg: resultKordan
  }
]
